// 将承诺书和签名合成一张新的承诺书
<template>
  <div class="all_box">
    <div class="cover_container">
      <img class="commitment_box" crossorigin="anonymous"  :src="commitmentObj.commitmentUrl" alt="" />
      <div class="flexbox sign_box">
      用户签名:<img :src="commitmentObj.signUrl" alt="" crossorigin="anonymous" />
    </div>
    </div>
  </div>
</template>

<script>
import { base64ToBlob, compressImg } from '@/utils'
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('goods/vip', ['commitmentObj'])
  },
  created() {},

  methods: {
    // 生成带签名的承诺书截图
    makeCommitment() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '申请资料上传中...',
        forbidClick: true
      })
      const capture = document.querySelector('.all_box')
      html2canvas(capture, {
        useCORS: true,
        width: capture.offsetWidth,
        height: capture.offsetHeight,
        scale: 2
      })
        .then((canvas) => {
          const image = canvas.toDataURL('image/png')
          compressImg(image, 0.9, 1, '仅供友邻认证', (res) => {
            const base64 = res.split(',')[1]
            base64ToBlob({ b64data: base64, contentType: 'image/png' }).then(
              (res) => {
                this.upLoad(res)
              }
            )
          })
        })
        .catch(() => {
          Toast.clear()
        })
    },
    upLoad(src) {
      this.$store
        .dispatch('goods/vip/imageTokenH5', {})
        .then((data) => {
          this.$store
            .dispatch('goods/vip/uploadAliyun', { data, src })
            .then((res) => {
              console.log('签名承诺书截图:', res)
              this.$store.commit('goods/vip/saveCommitmentDetails', {
                commitmentUrl: res
              })
              this.$emit('makeSuccess')
              Toast.clear()
            })
        })
        .catch((err) => {
          console.log('获取pocily err', err)
          Toast.clear()
          this.$toast({
            message: '我开小差了，请刷新重试'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cover_container {
  position: relative;
  // padding: 0.32rem;
  img {
    display: block;
    width: 100%;
  }
}
.sign_box {
  background: #fff;
  font-size: 0.24rem;
  position: absolute;
  bottom: 0.66rem;
  right: 0.66rem;
  z-index:2;
  img {
    display: block;
    width: 2rem;
    height: 1.3rem;
  }
}
</style>
